var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-content" }, [
    _c("div", { staticClass: "container--fluid upper-content" }, [
      _c(
        "div",
        { staticClass: "upper-content__table" },
        [
          _vm.reportsData
            ? _c("ReportsTable", { attrs: { "table-data": _vm.reportsData } })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }